export default {
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/vercel/path0/layouts/empty.vue").then(m => m.default || m)
}